import { render, staticRenderFns } from "./OrderShuttle.vue?vue&type=template&id=c3f8c3c6&scoped=true&"
import script from "./OrderShuttle.vue?vue&type=script&lang=js&"
export * from "./OrderShuttle.vue?vue&type=script&lang=js&"
import style0 from "./OrderShuttle.vue?vue&type=style&index=0&id=c3f8c3c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f8c3c6",
  null
  
)

export default component.exports